import React from 'react';
import './About.css';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import backgroundImage from '../assets/basketball-bg.jpg';
import ebonyImage from '../assets/team/ebony.jpg';
import tylerImage from '../assets/team/tyler.jpg';
import jenniferImage from '../assets/team/jennifer.jpg';
import { useMediaQuery } from 'react-responsive';
import MobileAbout from './mobile/MobileAbout';
import { Helmet } from 'react-helmet-async';

const teamMembers = [
  {
    name: "Ebony Annor",
    role: "Host",
    bio: "Hello? Is this thing on? Okay lets do this one last time. My name is Ebony-Jade Annor. " +
         "I was bitten by a radioactive basketball, and for the last 24 years I've been the one and only, real life Midorima. " +
         "I'm pretty sure you know the rest. Watched my brothers play when I was younger, started playing when I was 8, " +
         "fell in love with it, decided to support this team called Miami heat, Jimmy Butler became my favourite player, " +
         "became a coach, played in Malaysia a couple of times, got knocked down a few times, sometimes I just wish I wasn't the only one, " +
         "but I don't dwell on it… I miss my dad sometimes, I try and do what he told me, just keep going, at the end of the day I'm me, " +
         "I'm Ebony, and no one can take that away from me, so yeah join me on this new adventure and we can have some fun 😁.",
    image: ebonyImage
  },
  {
    name: "Tyler Annor",
    role: "Host",
    bio: "Growing up with older siblings who played basketball, it was only natural for me to have watched, played, and ultimately fall in love with basketball too. " +
         "I played for numerous clubs both locally and at a representative level (West Sydney Wolves and Bankstown Bruins), and due to an abundance of support from coaches and peers, " +
         "I was able to have the opportunity to play in the United States through a scholarship. " +
         "Although I've stepped away from playing, I still hold that same obsession I grew up with. Through this podcast, I would love to showcase both that passion and how " +
         "the underrated sides of hoop culture (aside from hooping itself) can still be fascinating in their own right, especially through the stories and experiences of our guests!",
    image: tylerImage
  },
  {
    name: "Jennifer Bioh",
    role: "Producer",
    bio: "Outside of my office day job in accounts, I love making basketball content for my socials. " +
         "I volunteer as a coach for youth basketball with an amazing organisation Charity Bounce. " +
         "\n\n" +
         "I literally love anything to do with basketball and my family would constantly say \"all you talk about is basketball.\" " +
         "So it just made sense to create and become the producer for a podcast about basketball and its culture. " +
         "\n\n" +
         "I get to hear the full uncut version of all the amazing stories and conversations from our amazing hosts and guests in real time. " +
         "I get to then rewatch the raw version and edit it to podcast perfection, to share it with our viewers. " +
         "To help grow the love of basketball culture.",
    image: jenniferImage
  },
  {
    name: "Keith Li & Ronny Diamond",
    role: "Faceless Operators Behind Basketball Culture Podcast",
    bio: "Makes sure everything runs smoothly from start to finish. They handle everything from setting up cameras and directing the show to managing live operations and fine-tuning the audio on the fly. Whether it's a live broadcast or a recorded episode, delivering top-tier basketball conversation. If everything runs perfectly that's thanks to them-if not, let's just call it a \"technical difficulty\".",
  }
];

const About = () => {
  useScrollAnimation([]);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  if (isMobile) {
    return <MobileAbout teamMembers={teamMembers} />;
  }

  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Basketball Culture Podcast",
    "description": "Basketball is more than a game, it is a culture which influences multiple areas in society...",
    "url": "https://basketballculturepodcast.com",
    "sameAs": [
      "https://www.youtube.com/@BasketballCulturePodcast",
      "https://www.instagram.com/xbasketballculture/",
      "https://www.tiktok.com/@xbasketball.culture",
      "https://open.spotify.com/show/5PeXtBE6kOmkQkY6apnagZ"
    ]
  };

  return (
    <div className="about-page">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(aboutSchema)}
        </script>
      </Helmet>
      <div 
        className="about-hero"
        style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url(${backgroundImage})` }}
      >
        <h1 className="about-title scroll-animate">
          ABOUT<span>US</span>
        </h1>
      </div>
      
      <div className="about-content">
        <div className="about-container">
          <div className="mission-section scroll-animate">
            <h2>Our Mission</h2>
            <div className="mission-content">
              <p>Basketball is more than a game, it is a culture which influences multiple areas in society, such as music, art, fashion and community. We believe in the cultural importance of basketball which has played a pivotal role on the courts for at-risk youth and community.</p>
              
              <p>Globally basketball traces its roots back to the streets, ghettos and amazing young people; intertwining with music and urban art. The sport has flourished today alongside urban culture and art, with graffiti walls serving as a backdrop to the rhythms of hip-hop and R&B music.</p>
              
              <p>Also today more than ever, the sneaker culture and fashion has become an essential aspect of basketball culture. It has influenced street wear with professional basketball players serving as an inspiration for urban fashion trends.</p>
              
              <p>Just like how basketball culture intertwines in all these areas and brings people of all walks of life together, we wish to do the same with our podcast by presenting guests from across all these areas and learn how the game has shaped, brought life lessons and made our guests who they are today.</p>
              
              <p className="mission-highlight">Here at Basketball Culture Podcast, we aim to entertain and help grow the culture. We hope you join us in our journey.</p>
            </div>
          </div>
          
          <div className="team-section scroll-animate">
            <h2>The Team</h2>
            <div className="team-members">
              {teamMembers.map((member, index) => (
                <div className={`team-member scroll-animate ${!member.image ? 'no-image' : ''}`} key={index}>
                  {member.image && (
                    <div className="member-image">
                      <img src={member.image} alt={member.name} />
                    </div>
                  )}
                  <div className="member-info">
                    <h3>{member.name}</h3>
                    <p className="role">{member.role}</p>
                    <p className="bio">{member.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 